var $ = window.jQuery;
$(document).ready(function() {
	console.log("Inside Testimonial Scroll.js");

	var autoAdvanceTimer;

	function nextTestimonial() {
		var $this = $('.testimonial--current');
		var $next = $this.next('blockquote');
		if ($next.length === 0) {
			$next = $this.siblings('blockquote:first');
		}
		$this.animate({opacity: 0}, 500, 'swing', function() {
			$this.removeClass('testimonial--current').css('opacity', 1);
			$next.addClass('testimonial--current').css('opacity', 0).animate({opacity: 1}, 500, 'swing');
		});
	}

	function startAutoAdvance() {
		autoAdvanceTimer = setInterval(nextTestimonial, 10000);
	}

	function resetAutoAdvance() {
		clearInterval(autoAdvanceTimer);
		startAutoAdvance();
	}

	$('.button--next').on('click', function() {
		nextTestimonial();
		resetAutoAdvance();
	});

	$('.button--prev').on('click', function() {
		var $this = $('.testimonial--current');
		var $prev = $this.prev('blockquote');
		if ($prev.length === 0) {
			$prev = $this.siblings('blockquote:last');
		}
		$this.animate({opacity: 0}, 500, 'swing', function() {
			$this.removeClass('testimonial--current').css('opacity', 1);
			$prev.addClass('testimonial--current').css('opacity', 0).animate({opacity: 1}, 500, 'swing');
		});
		resetAutoAdvance();
	});

	// Start auto-advance on page load
	startAutoAdvance();
});
